import React from "react";
import MainMenuDisplay from "../../Display/Menu/MainMenuDisplay";

const MainMenuContainer = () => {
  return <MainMenuDisplay />;
};

export default MainMenuContainer;
